export default __webpack_public_path__ + "static/media/trade_06.423d6ae8.png";